import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';
import {Formik} from 'formik';
import {isEqual} from 'lodash';
import moment from 'moment';
import {useProjectsUIContext} from '../ProjectsUIContext';
import FilterTextField from '../../../_common/components/FilterTextField';
import {FilterFromDate, FilterToDate} from '../../../_common/components/FilterDateRange';
import PopupCreateProject from '../PopupCreateProject/PopupCreateProject';
import {RequestCancellationManager} from '../../../_common/utils/RequestCancellationManager';
import {getProjectsListIDPrefix} from '../../_redux/projectsActions';
import FiltersBar from '../../../_common/components/FiltersBar';

const prepareFilter = (queryParams, values) => {
  const {name, fromDate, toDate} = values;
  const newQueryParams = {...queryParams};
  const filter = {};
  if (Boolean(name)) {
    filter.name = name;
  } else {
    delete newQueryParams.name;
  }
  if (Boolean(fromDate)) {
    filter.fromDate = moment(fromDate).format('YYYY-MM-DD');
  } else {
    delete newQueryParams.fromDate;
  }
  if (Boolean(toDate)) {
    filter.toDate = moment(toDate).add(1, 'days').format('YYYY-MM-DD');
  } else {
    delete newQueryParams.toDate;
  }

  return {...newQueryParams, ...filter};
};

export function ProjectsFilter() {
  const intl = useIntl();
  const projectsUIContext = useProjectsUIContext();
  const projectsUIProps = useMemo(() => {
    return {
      queryParams: projectsUIContext.queryParams,
      setQueryParams: projectsUIContext.setQueryParams,
    };
  }, [projectsUIContext]);

  const applyFilter = (values) => {
    RequestCancellationManager.stopRequests(getProjectsListIDPrefix);
    const newQueryParams = prepareFilter(projectsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, projectsUIProps.queryParams)) {
      projectsUIProps.setQueryParams(newQueryParams);
    }
  };

  const qs = new URLSearchParams(window.location.search);
  const name = qs.get('name') || '';
  const fromDate = qs.get('fromDate') || '';
  const toDate = Boolean(qs.get('toDate'))
    ? moment(qs.get('toDate')).subtract(1, 'days').toDate()
    : '';

  const containerClassnames = 'w-200px position-relative my-1 px-3';

  return (
    <Formik
      initialValues={{
        name,
        fromDate,
        toDate
      }}
      onSubmit={(values) => applyFilter(values)}
      enableReinitialize={true}
    >
      {({values, ...formikProps}) => (
        <FiltersBar
          filters={
            <div className={'d-flex flex-wrap justify-content-center align-items-center mb-0 w-100'}>
              <FilterTextField
                fieldName="name"
                placeholder={intl.formatMessage({id: 'automatedPayments-filter-name', defaultMessage: 'Name'})}
                value={values.name}
                containerStyles={containerClassnames}
                {...formikProps}
              />
              <FilterFromDate
                values={values}
                containerStyles={containerClassnames}
                {...formikProps}
              />
              <FilterToDate
                values={values}
                containerStyles={containerClassnames}
                {...formikProps}
              />
            </div>
          }
          buttons={
            <div className={'w-800px d-flex justify-content-end'}>
              <PopupCreateProject/>
            </div>
          }
        />
      )}
    </Formik>
  );
}
